import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Hamdan_Sports_complex.webp';

const Project_one = () => {

  return (
     <>
    
          <div className='project_1_work' id="workBanner">
    
            <div className="container project_our_work">
    
              <div className="heading">
                <h1>Hamdan Sports Complex</h1>
              </div>
    
              <hr></hr>
              <div className='project_section'>
                <div className="project_section_content">
                  <h1 className="project_scope">Scope of Work</h1>
                  <p>One of Dubai's premier multi-sport facilities, home to major athletics, cycling and indoor sports events. The complex hosts
                international competitions and serves as a centre of excellence for sports development and athlete training across the UAE.</p>
                  <p>MAIN CONTRACTOR : Binladin</p>
                  <p>MEP CONTRACTOR : -</p>
                  <p>GEMCO SCOPE OF WORKS : CHW and ducting works</p>
                  {/* <h2 className="project_years">2014 – 2022</h2> */}
                </div>
                <div className='project_1_card'>
                  <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                </div>
              </div>
            </div>
          </div>
    
        </>

  )
}

export default Project_one